import { createSourcingRequestEmbeddedConfig } from './sourcing-request-embedded.factory';

/**
 * Sourcing Request embedded list — scoped to a single client.
 * Mounted on the Client Detail "Sourcing Requests" tab. The clientId
 * filter is applied at the tab/queryFn layer (not here) so the same
 * config powers any client.
 */
export const SOURCING_REQUEST_CLIENT_EMBEDDED_CONFIG =
	createSourcingRequestEmbeddedConfig({
		id: 'default-sourcing-requests-client-embedded',
		name: 'Client Sourcing Requests',
	});
